<script lang="ts">
  export let title: string;
  export let colour = "#C91800";
  export let bgColour = "#EDD7D4";
  export let className = "";
  export let hide = "";

  function showoption(hide: string) {
    if (hide === "mob") {
      return "desk-only";
    } else if (hide === "desk") {
      return "mob-only";
    } else {
      return "";
    }
  }

  function genStyle() {
    const retVal: string[] = [];
    colour && retVal.push(`color:${colour}`);
    bgColour && retVal.push(`background-color:${bgColour}`);
    return retVal.join(";");
  }
  const classes = ["sugg-wrapper", "pf-500", className.toLowerCase().replaceAll(" ", "-"), showoption(hide)].join(" ");
</script>

<div>
  <div class={classes} style={genStyle()}>
    {(title || "").replaceAll("-", " ")}
  </div>
</div>

<style lang="scss">
  .sugg-wrapper {
    display: flex;
    flex-direction: column;
    border-radius: 0.3em;
    color: #fff;
    font-size: 0.75em;
    font-style: normal;
    line-height: 0.91667em; /* 11px; */
    padding: 5px 8px;
    align-items: flex-start;
    gap: 10px;
  }
</style>
